import * as React from 'react';
import Slide from '@mui/material/Slide';

// Helper function to create safe transition handlers
// Exported for use in other components (e.g., GrowTransition)
export const createSafeTransitionHandlers = (props) => {
  const { onEnter, onEntering, onEntered, onExit, onExiting, onExited } = props;
  
  return {
    handleEnter: (node, isAppearing) => {
      // Guard against null node (prevents "scrollTop" crash)
      if (!node) return;
      if (onEnter) {
        onEnter(node, isAppearing);
      }
    },
    handleEntering: (node, isAppearing) => {
      if (!node) return;
      if (onEntering) {
        onEntering(node, isAppearing);
      }
    },
    handleEntered: (node, isAppearing) => {
      if (!node) return;
      if (onEntered) {
        onEntered(node, isAppearing);
      }
    },
    handleExit: (node) => {
      if (!node) return;
      if (onExit) {
        onExit(node);
      }
    },
    handleExiting: (node) => {
      if (!node) return;
      if (onExiting) {
        onExiting(node);
      }
    },
    handleExited: (node) => {
      if (!node) return;
      if (onExited) {
        onExited(node);
      }
    }
  };
};

// Fixed Transition component to prevent null node errors in React 18
// Guards against null nodes before Material-UI's Slide accesses scrollTop
const Transition = React.forwardRef(function Transition(props, ref) {
  const { onEnter: _onEnter, onEntering: _onEntering, onEntered: _onEntered, onExit: _onExit, onExiting: _onExiting, onExited: _onExited, ...otherProps } = props;
  const handlers = createSafeTransitionHandlers(props);

  return (
    <Slide
      direction="up"
      ref={ref}
      {...otherProps}
      onEnter={handlers.handleEnter}
      onEntering={handlers.handleEntering}
      onEntered={handlers.handleEntered}
      onExit={handlers.handleExit}
      onExiting={handlers.handleExiting}
      onExited={handlers.handleExited}
    />
  );
});

export default Transition;

